<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 my-4 font-weight-bold">{{ appNameDesktop }}</div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="link-list-wrapper">
                    <ul class="link-list">
                        <li class="list-item"><a [routerLink]="['/cms', 'contatti']">Contatti</a></li>
                        <li class="list-item"><a [routerLink]="['/cms', 'privacy']">Privacy</a></li>
                        <li class="list-item"><a [routerLink]="['/cms', 'note-legali']">Note legali</a></li>
                      
                    </ul>
                </div>
            </div>
            <div class="col-md-3">
                <div class="link-list-wrapper">
                    <ul class="link-list">
                        <li class="list-item"><a [routerLink]="['/cms', 'accessibilita']">Accessibilità</a></li>
                        <li class="list-item"><a [routerLink]="['/cms', 'cookie-policy']">Cookie policy</a></li>
                        <li class="list-item"><a style="cursor:pointer;" (click)="downloadManuale()">Manuale</a></li>                    
                    </ul>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 my-3">
                <span class="d-inline-block">&copy; Copyright Regione Lombardia</span>
                <span class="d-inline-block"> - tutti i diritti riservati</span>
                <span class="d-inline-block"> - C.F. 80050050154</span>
                <span class="d-inline-block"> - Piazza Città di Lombardia 1</span>
                <span class="d-inline-block"> - 20124 Milano</span>
            </div>
        </div>
    </div>
</footer>